import * as React from "react";
import { cn } from "../../lib/utils";

/**
 * Theme-aware checkbox control (matches Switch accent / border tokens).
 * @param {Object} props
 * @param {boolean} [props.checked]
 * @param {function(boolean): void} [props.onCheckedChange]
 * @param {boolean} [props.disabled]
 * @param {string} [props.className]
 * @param {string} [props.id]
 * @returns {JSX.Element}
 */
const Checkbox = React.forwardRef(
  ({ className, checked = false, onCheckedChange, disabled, id, ...props }, ref) => {
    return (
      <button
        type="button"
        role="checkbox"
        id={id}
        aria-checked={checked}
        disabled={disabled}
        ref={ref}
        {...props}
        onClick={(event) => {
          props.onClick?.(event);
          if (event.defaultPrevented || disabled) return;
          onCheckedChange?.(!checked);
        }}
        className={cn(
          "inline-flex h-4 w-4 shrink-0 items-center justify-center rounded border-2 transition-colors duration-200 ease-out",
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ui-ring focus-visible:ring-offset-2 focus-visible:ring-offset-ui-background",
          "disabled:cursor-not-allowed disabled:opacity-50",
          checked
            ? "border-accent bg-accent text-text-on-accent"
            : "border-ui-border bg-ui-card text-transparent",
          className
        )}
      >
        <svg
          viewBox="0 0 12 12"
          fill="none"
          aria-hidden="true"
          className={cn("h-3 w-3", checked ? "opacity-100" : "opacity-0")}
        >
          <path
            d="M2.5 6.2L4.8 8.5L9.5 3.5"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
    );
  }
);
Checkbox.displayName = "Checkbox";

export { Checkbox };
